import React, { useEffect, useState } from 'react';

function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      window.location.reload(); // Reloads the page when back online
    };

    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const clearCacheAndReload = async () => {
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      for (let name of cacheNames) {
        await caches.delete(name);
      }
    }
    window.location.reload(true); // true is legacy; modern browsers ignore it
  };

  if (isOnline) return null;

  return (
    <div style={styles.container}>
      <text>You are offline. Please check your internet connection.</text>
    </div>
  );
}

const styles = {
  container: {
    position: 'fixed',
    top: '0%',
    width: '100%',
    backgroundColor: 'red',
    color: 'white',
    textAlign: 'center',
    padding: '1em',
    zIndex: 2000,
  },
};

export default NetworkStatus;
